import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Financiar/ReconciliereModels.cs ----------

export type BankLineStatus = 'Nereconciliata' | 'Reconciliata' | 'Categorisita'
export type BankTransactionCategory = 'ComisioaneBancare' | 'DiferenteCurs' | 'Dobanzi' | 'TransferInterCont' | 'Salarii' | 'ObligatiiFiscale'
export const BANK_TRANSACTION_CATEGORY_LABEL: Record<BankTransactionCategory, string> = {
  ComisioaneBancare: 'Comisioane bancare', DiferenteCurs: 'Diferențe de curs', Dobanzi: 'Dobânzi',
  TransferInterCont: 'Transfer între conturi proprii', Salarii: 'Salarii', ObligatiiFiscale: 'Obligații fiscale',
}

export interface BankStatementImport {
  id: string
  cashAccountId: string
  cashAccountName: string
  fileName: string
  importedAt: string
  importedByUserName: string
  lineCount: number
  reconciledCount: number
  skippedRowCount: number
}

export interface BankStatementLine {
  id: string
  bankStatementImportId: string
  transactionDate: string
  description: string
  reference: string | null
  amount: number
  status: BankLineStatus
  matchedReceiptId: string | null
  matchedReceiptNumber: string | null
  matchedPaymentId: string | null
  matchedPaymentNumber: string | null
  category: BankTransactionCategory | null
  categoryNotes: string | null
  reconciledAt: string | null
}

export interface BankMatchCandidate {
  receiptId: string | null
  receiptNumber: string | null
  paymentId: string | null
  paymentNumber: string | null
  partnerName: string
  date: string
  amount: number
  score: number
}

export interface ImportBankStatementResult { importId: string; lineCount: number; skippedRowCount: number }

export const importBankStatement = (cashAccountId: string, file: File) => {
  const form = new FormData()
  form.append('cashAccountId', cashAccountId)
  form.append('file', file)
  return api.post<ImportBankStatementResult>('/financiar/reconciliere/import', form, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data)
}

export const listBankStatementImports = () => api.get<BankStatementImport[]>('/financiar/reconciliere/extrase').then((r) => r.data)
export const getBankStatementLines = (importId: string) =>
  api.get<BankStatementLine[]>(`/financiar/reconciliere/extrase/${importId}/linii`).then((r) => r.data)
export const getMatchCandidates = (lineId: string) =>
  api.get<BankMatchCandidate[]>(`/financiar/reconciliere/linii/${lineId}/sugestii`).then((r) => r.data)
export const reconcileLine = (lineId: string, payload: { receiptId: string | null; paymentId: string | null }) =>
  api.post(`/financiar/reconciliere/linii/${lineId}/reconciliaza`, payload)
export const undoReconcile = (lineId: string) => api.post(`/financiar/reconciliere/linii/${lineId}/anuleaza-reconciliere`)
export const categorizeLine = (lineId: string, payload: { category: BankTransactionCategory; notes: string | null }) =>
  api.post(`/financiar/reconciliere/linii/${lineId}/categorizeaza`, payload)

// ---------- FR-FCF-012 — poziție de cash ERP ↔ bancă ----------

export interface CashPositionUnmatchedErpEntry { type: 'Incasare' | 'Plata'; id: string; number: string; date: string; amount: number; partnerName: string }
export interface CashPositionUnmatchedBankLine { lineId: string; transactionDate: string; description: string; amount: number }
export interface CashPositionCategorizedLine {
  lineId: string; transactionDate: string; description: string; amount: number
  category: BankTransactionCategory; notes: string | null
}

export interface CashPositionReport {
  cashAccountId: string; cashAccountName: string; from: string; to: string
  soldInitial: number; totalIntrariErp: number; totalIesiriErp: number; soldFinalErp: number
  totalIntrariExtras: number; totalIesiriExtras: number; soldFinalBancar: number
  inregistrariErpFaraCorespondent: CashPositionUnmatchedErpEntry[]
  tranzactiiBancareNeinregistrate: CashPositionUnmatchedBankLine[]
  tranzactiiCategorisite: CashPositionCategorizedLine[]
}

export const getCashPositionReport = (cashAccountId: string, from: string, to: string) =>
  api.get<CashPositionReport>('/financiar/reconciliere/pozitie', { params: { cashAccountId, from, to } }).then((r) => r.data)
